import { EMPTY_ARRAY, type MarketAccount, type Security } from '@talos/kyoko';

/**
 * Given the security and selected markets and market accounts, will return the selected markets and accounts that are
 * valid for the Security. This is used when for example disabling UL and you need to remove any selections no longer applicable,
 * or if you need to figure out which markets are UL markets and which are "native" markets
 */
export function getSymbolAndMarketsNoUnifiedLiquidity({
  security,
  marketAccountSelections,
  marketSelections,
  marketAccountsByName,
}: {
  security: Pick<Security, 'Symbol' | 'Markets'> | undefined;
  marketAccountSelections: string[] | undefined;
  marketSelections: string[] | undefined;
  marketAccountsByName: ReadonlyMap<string, Pick<MarketAccount, 'Market'> | undefined>;
}) {
  const selectedMarketAccounts = marketAccountSelections ?? EMPTY_ARRAY;
  const selectedMarkets = marketSelections ?? EMPTY_ARRAY;
  const symbolMarketsSet = new Set(security?.Markets ?? EMPTY_ARRAY);

  const narrowedMarketsAccounts = selectedMarketAccounts.filter(mktAcc => {
    const marketAccount = marketAccountsByName.get(mktAcc);
    if (!marketAccount?.Market) {
      return false;
    }
    return symbolMarketsSet.has(marketAccount?.Market);
  });

  const narrowedMarkets = selectedMarkets.filter(market => symbolMarketsSet.has(market));

  return {
    symbol: security?.Symbol,
    marketAccounts: narrowedMarketsAccounts,
    markets: narrowedMarkets,
  };
}
